'use strict';

/* globals define, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/groups/settings-page', [
	'settings-page-details',
	'settings-page-categories',
], function (settingsPageDetails, settingsPageCategories) {
	var	Settings = {};

	Settings.init = function () {
		settingsPageDetails.init();
		settingsPageCategories.init();
	};

	return Settings;
});
